import { Component } from '@verndale/core';

export const spinner = `
<div class="spinner">
  <div class="spinner__icon">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
`;

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $status: this.el._$('.rmpc-dashboard__status'),
      $statusPrefix: this.el._$('.rmpc-dashboard__status-prefix'),
      $statusContent: this.el._$('.rmpc-dashboard__status-content'),
      $dashboardIdPrefix: this.el._$('.rmpc-dashboard__dashboard-id-prefix'),
      $dashboardIdContent: this.el._$('.rmpc-dashboard__dashboard-id-content'),
      $dashboardLink: this.el._$('.rmpc-dashboard__dashboard-id-link'),
      $statusCheck: this.el._$('.rmpc-dashboard__status-check'),
      $dashboardInfoWrapper: this.el._$('.rmpc-dashboard__status-info-wrapper'),
      $form: this.el._$('form')
    };

    this.endpoint = this.el.dataset.endpoint;
    this.statusPrefix = this.el.dataset.statusPrefix || 'Status:';
    this.dashboardIdPrefix = this.el.dataset.dashboardIdPrefix || 'Dashboard Id:'
    this.errorMessage =
    this.el.dataset.errorMessage || 'ERROR - Failed getting RMPC status';
    this.blueClass = 'rmpc-dashboard__status--blue';
    this.redClass = 'rmpc-dashboard__status--red';

    this.dom.$loadingRing = document.createElement('div');
    this.dom.$loadingRing.classList.add('loading-ring');
    this.dom.$loadingRing.setAttribute('role', 'presentation');
    this.dom.$loadingRing.innerHTML =
      '<div></div><div></div><div></div><div></div>';

    this.getRMPCStatus();
  }

  addListeners() {
    this.dom.$form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(this.dom.$form);
    const submitButton = this.dom.$form._$('button[type="submit"]');

    submitButton.disabled = true;
    submitButton.appendChild(this.dom.$loadingRing);

    let filename;
    fetch(e.currentTarget.getAttribute('action'), {
      method: 'POST',
      body: formData
    })
      .then(res => {
        const header = res.headers.get('Content-Disposition');
        const parts = header.split(';');
        filename = parts[1].split('=')[1];
        return res.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(console.error)
      .finally(() => {
        this.dom.$loadingRing.remove();
        submitButton.disabled = false;
      });
  }

  getRMPCStatus() {
    this.insertSpinner();
    window
      .fetch(this.endpoint)
      .then(response => response.json())
      .then(data => this.handleFetchSuccess(data))
      .catch(response => this.handleFetchError(response))
      .finally(() => this.removeSpinner());
  }

  insertSpinner() {
    this.el.insertAdjacentHTML('beforeend', spinner);
  }

  removeSpinner() {
    const spinner = this.el.querySelector('.spinner');

    if (spinner) {
      spinner.remove();
    }
  }

  handleFetchSuccess(data) {
    const color = data['Color'].toLowerCase();
    this.dom.$dashboardInfoWrapper.hidden = false;

    this.dom.$status.hidden = !data.Status;

    if (color === 'blue') {
      this.dom.$status.classList.add(this.blueClass);
    } else if (color === 'red') {
      this.dom.$status.classList.add(this.redClass);
    }

    this.dom.$statusPrefix.innerHTML = this.statusPrefix;
    this.dom.$statusContent.innerHTML = data['Status'];
    this.dom.$dashboardIdPrefix.innerHTML = this.dashboardIdPrefix;
    this.dom.$dashboardIdContent.innerHTML = data['DashboardId'];
    this.dom.$dashboardLink.href = data['DashboardLink'];

    if (typeof data['DashboardId'] === 'undefined' || typeof data['DashboardLink'] === 'undefined') {
      this.dom.$dashboardInfoWrapper.hidden = true;
    }

    if (data['Status'].toLowerCase() === 'rmpc complete') {
      this.dom.$statusCheck.style.display = 'flex';
    }
  }

  handleFetchError(response) {
    this.dom.$status.hidden = true;
    this.dom.$status.classList.add(this.redClass);
    this.dom.$statusPrefix.innerHTML = this.statusPrefix;
    this.dom.$statusContent.innerHTML = this.errorMessage;
  }
}

export default Module;
